const ExpandCollapseLinks = () => (
  <div className="cb-accordion-controls">
    <button className="expand-all btn cb-accordion-btn">Expand All</button>
    <span className="cb-separator"></span>
    <button className="collapse-all btn cb-accordion-btn">Collapse All</button>
  </div>
)

class Panel extends Component {
  constructor(props) {
    super()
    this.state = { loadBody: props.openByDefault || false }
    this.togglePanelOpen = this.togglePanelOpen.bind(this)
  }

  togglePanelOpen() {
    this.setState({ loadBody: !this.state.loadBody })
  }

  render() {
    const { PanelBody, openByDefault, id, title, panelId } = this.props
    const { loadBody } = this.state
    const { SPACE } = APRICOT.utils.keys

    return (
      <div className="panel panel-default" id={panelId}>
        <div className="panel-heading">
          <h4 className="panel-title">
            <a
              className={openByDefault ? 'cb-accordion-show' : 'collapsed'}
              role="button"
              data-toggle="collapse"
              data-parent={`#${id}`}
              onClick={this.togglePanelOpen}
              aria-expanded={loadBody}
              onKeyDown={e => {
                // Space key should also expand/collapse accordion
                if (e.keyCode === SPACE) this.togglePanelOpen()
              }}
            >
              {typeof title === 'string' ? title : <this.props.title />}
            </a>
          </h4>
        </div>
        <div className={`panel-collapse collapse ${openByDefault ? 'in' : ''}`}>
          <div className="panel-body">{loadBody ? <PanelBody panelIsOpen={loadBody} /> : null}</div>
        </div>
      </div>
    )
  }
}

export default class Accordions extends Component {
  constructor() {
    super()
    this.container = createRef()
  }

  componentDidMount() {
    //make sure apricot initializes accordion, so accessibility elements are automatically added
    $(this.container.current).cbAccordion()
  }

  render() {
    const { showExpandCollapse = false, id, panels } = this.props

    return (
      <div className="cb-accordion" ref={this.container}>
        {showExpandCollapse ? <ExpandCollapseLinks /> : null}
        <div className="panel-group" role="tablist" id={id} aria-multiselectable="true">
          {panels.map((p, i) => (
            <Panel key={i} {...p} id={id} />
          ))}
        </div>
      </div>
    )
  }
}
